import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../../components/Shared/Spinner";
import Input from "../../components/Shared/Input";
import { useParams } from "react-router-dom";
import AttempsTable from "../../components/Dashboard/Students/AttempsTable";
import { GetStudentAttemps } from "../../api/Students/GetStudentAttemps";

const StudentAttemps = () => {
  const { studentId } = useParams();
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [jumpPage, setJumpPage] = useState(1);

  const { data: StudentsResponse, isLoading: isStudentsLoading } = useQuery({
    queryFn: () =>
      GetStudentAttemps({
        page,
        limit,
        studentId: studentId || "",
      }),
    queryKey: ["studentAttemps", studentId, page, limit],
    staleTime: 0,
    refetchInterval: 0,
  });

  const handleNextPage = () => setPage((prev) => prev + 1);
  const handlePreviousPage = () => setPage((prev) => Math.max(prev - 1, 1));
  const handleJumpPage = () => setPage(jumpPage);

  const attemps = StudentsResponse?.data?.data || [];
  const metaData = StudentsResponse?.data?.metaData || {
    totalPages: 1,
  };

  if (isStudentsLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="py-7">
      <h1 className="text-burntBlack font-bold text-[32px] mb-7">Students</h1>
      <div className="p-8 rounded-xl bg-white border-black/15 shadow">
        <h1 className="font-bold text-2xl mb-8">Student Login Attempts</h1>

        <AttempsTable data={attemps} />

        <div className="flex justify-between items-center mt-4">
          <button
            onClick={handlePreviousPage}
            disabled={page === 1}
            className="bg-blue-500 text-white px-4 py-2 rounded disabled:bg-gray-400"
          >
            Previous
          </button>
          <span>
            Page {page} of {metaData?.totalPages || 1}
          </span>
          <button
            onClick={handleNextPage}
            disabled={!metaData || page >= metaData.totalPages}
            className="bg-blue-500 text-white px-4 py-2 rounded disabled:bg-gray-400"
          >
            Next
          </button>
        </div>

        <div className="flex justify-center items-center mt-4">
          <Input
            name="Page"
            type="number"
            value={jumpPage.toString()}
            className="md:!space-y-0"
            inputStyles="!h-10 !rounded"
            onChange={(e) => setJumpPage(Number(e.target.value))}
          />
          <button
            onClick={handleJumpPage}
            className="bg-blue-500 text-white px-4 h-10 rounded disabled:bg-gray-400"
          >
            Jump to Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentAttemps;
